import { render, staticRenderFns } from "./TengoUnDato.vue?vue&type=template&id=70e770cb"
import script from "./TengoUnDato.vue?vue&type=script&lang=js"
export * from "./TengoUnDato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports